import React, { useState } from 'react';
import { Button, Collapse } from 'reactstrap';

import { WhitePanel } from '../index';

import config from '../../config';

export function FAQ() {
  return (
    <WhitePanel>
      <h2>FAQS</h2>
      <Accordian title="Booking and Confirmation">
        <Group>
          <Question question="Do I need to confirm my transport booking?" />
          <Answer>
            No. Once your transport is booked, you do not need to reconfirm it. As soon as the booking process is complete, we will send you an email with an e-ticket and necessary details of your confirmed booking. You are requested to check your spam folder as well.
            If you do not receive tickets within 30 minutes, please email us at <Email /> or Call/ Whatsapp us at <Call />.
          </Answer>

          <Question question="Do I need to print my ticket?" />
          <Answer>
            No. You can simply show your confirmation email of payment at the Transport Counter via any devices like phone or tablet. However, please make sure that you have downloaded the tickets and there’s no issue with device battery.
          </Answer>
        </Group>
      </Accordian>

      <Accordian title="Payment Options">
        <Group>
          <Question question="What are my flight booking and payment options?" />
          <Answer>
          The standard way of booking your ride is through HoneyGuide’s website.
          
          However, if you aren’t able to book your vehicle due to payment failure or any other issue, you can write to us at <Email/> or contact us on Whatsapp <Call />. We will help you book your ride and arrange an alternative medium of payment (either wire transfer or cash payment before 72 hours). The Information we will need to make a reservation are:
          The Date for when you wish to make a reservation and the Number of people.
          Scanned Copies of Passport of all the passengers.
          Valid email address and contact numbers.
          </Answer>
        </Group>
      </Accordian>
      <Accordian title="Changes in Reservation">
        <Group>
          <Question question="How Do I Change a Transport Reservation?"/>
          <Answer>
            If you wish to reschedule the transport date or times, you can email us at <Email/> or WhatsApp us at <Call/>.
          </Answer>

          <Question question="Is there any fee/charge if I want to change myTransport Reservation?"/>
          <Answer>
            No. There is no fee/charge for making changes to your transport reservation unless you wish to cancel your reservation. You have to make the changes at least 72 hours prior your scheduled booking date.
          </Answer>
          
          <Question question="How Do I Make Changes to Booking Information in case of mistakes and name changes?"/>
          <Answer>
            If you wish to make any changes to your reservation (e.g., name changes, or email address correction), you can email us at <Email />.
          </Answer>

          <Question question="Can I change my transport booking date if I finish my trek earlier?"/>
          <Answer>
          Yes. If you finish your trek earlier, you can request a change of transport date. HoneyGuide will make changes if there are seats available for the earlier for your desired date. You can email us at <Email />. 
          </Answer>
        </Group>
      </Accordian>

      <Accordian title="Cancellations and Refunds">
        <Group>
          <Question question="How Do I Cancel a Transport Reservation?"/>
          <Answer>
          If you wish to cancel your transport reservation, please email us at <Email /> or Call/Whatsapp us at <Call />. We will cancel your reservation and initiate the refund process. Generally, the refund process takes 15-20 days. If you don’t receive your funds back within that period, kindly write to us for further assistance.
          </Answer>

          <Question question="Is there any fee/ charge if I want to cancel my Transport  Reservation?"/>
          <Answer>
            HoneyGuide has a free cancellation before 48 hours from the booking date. After that, there will be no refund.
          </Answer>

          <Question question="What happens if my booked ride gets cancelled due to weather or any other unanticipated event?"/>
          <Answer>
            If your ride gets canceled, you have options to either shift your booking for the next day or get a full refund. 
            If you want to request a refund or change date, you can contact us via email at <Email /> or WhatsApp at <Call />. 
          </Answer>

          <Question question="What should I do if I miss my ride?"/>
          <Answer>
            If you miss your ride, please contact HoneyGuide for assistance. It is entirely up to the vehicle company to make decisions on matters like these.
            If you need to change your reservation, please contact HoneyGuide.
          </Answer>

          <Question question="How can I request a refund in case of transport cancellation or if I don’t claim the ride?"/>
          <Answer>
            If you want to request a refund, please email us at <Email /> or call/ WhatsApp us at <Call />. Generally, the refund process takes 15-20 days. If you don’t receive your funds back within that period, kindly write to us for further assistance.
          </Answer>

          <Question question="How long does it take for funds to be refunded?"/>
          <Answer>
            Generally, the refund process takes 15-20 days after you request refunds. If you don’t receive your funds back within that period, kindly write to us at <Email /> for further assistance.
          </Answer>
        </Group>
      </Accordian>
      </WhitePanel>
  );
}



function Toggler({ initialValue=false, children }) {
  const [on, setOn] = useState(initialValue);

  const toggle = () => setOn(!on);

  const open = () => setOn(true);

  const close = () => setOn(false);

  return children({
    on,
    open,
    close,
    toggle,
  });
}

export function Accordian(props) {
  return (
    <Toggler initialOn={false}>
      {({ toggle, on }) => {
        return (
          <div className="flight-acc">
            <Button color="primary" onClick={toggle}>
              <h3>{props.title}</h3>{' '}
              <i className="icon icon-hg-chev-down" />
            </Button>
            <Collapse isOpen={on}>{props.children}</Collapse>
          </div>
        );
      }}
    </Toggler>
  );
}

Accordian.defaultProps = {
  isOpen: false,
};

export const Group = props => <div {...props} className="wrapper" />;

export const Question = props => <h5>{props.question}</h5>;

export const Answer = props => <p {...props} />;

export function Email() {
  return (
    <a href={`mailto:${config.honeyguideEmail}`}>{config.honeyguideEmail}</a>
  );
}

export function Call() {
  return (
    <React.Fragment>
      call / whatsapp us at
      <a
        target="_blank"
        href={`https://api.whatsapp.com/send?phone=${config.honeyguidePhoneNumber}`}
        rel="noopener noreferrer"
      >
        {' '}
        <b>{config.honeyguidePhoneNumber}</b>
      </a>
    </React.Fragment>
  );
}




// WEBPACK FOOTER //
// ./src/components/FAQ/FAQ.js